import { HttpParams, HttpUrlEncodingCodec } from '@angular/common/http';

class FixedHttpUrlEncodingCodec extends HttpUrlEncodingCodec {
  override encodeValue(value: string): string {
    const encodedValue = super.encodeValue(value);
    return encodedValue.replace(/\+/gi, '%2B');
  }
}

const encoder = new FixedHttpUrlEncodingCodec();

export const convertToHttpParams = <T extends { [K in keyof T]: string | number | boolean | null | undefined }>(model: T): HttpParams => {
  return Object.keys(model).reduce((params, p) => setOptionalParam(params, p, model[p as keyof T]), new HttpParams({ encoder }));
};

const setOptionalParam = (params: HttpParams, pName: string, pValue: string | number | boolean | null | undefined): HttpParams => {
  if (pValue === undefined) {
    return params;
  } else if (pValue === null) {
    return params.set(pName, '');
  } else {
    return params.set(pName, `${pValue}`);
  }
};
